import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';

import { ClientesUsuariosModel } from './clientes-usuarios.model';
import { BasicValidators } from '../shared/basic-validators';
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Funcoes} from "../funcoes";
import {PaisesService} from "../paises/paises.service";
import {Global} from "../global";
import {ClientesService} from "../clientes/clientes.service";
import {AdmClientesUsuariosService} from "./adm-clientes-usuarios.service";


@Component({
  selector: 'app-clientes-usuarios-form',
  templateUrl: './clientes-usuarios-form.component.html'
})
export class ClientesUsuariosFormComponent extends Components implements OnInit {

  form: FormGroup;
  title: string;
  user: ClientesUsuariosModel = new ClientesUsuariosModel();
  isMinhaConta: boolean = false;
  listPaises = [];
  listTimezone = [];
  listClientes = [];
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  obj = {"0":"3","1":"45"};

  constructor(
    formBuilder: FormBuilder,
    protected router: Router,
    private route: ActivatedRoute,
    private usuariosService: AdmClientesUsuariosService,
    private paisesService: PaisesService,
    private clientesService: ClientesService,
    private _location: Location,
    protected translate: TranslateService,
    public func: Funcoes,
    public global: Global
  ) {
    super();

    this.form = formBuilder.group({
      id_usuario: [],
      id_cliente: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      id_pais: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      cargo: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      email: ['', [
        Validators.required,
        BasicValidators.email
      ]],
      senha: ['', [Validators.minLength(8)]],
      senha_conf: ['', BasicValidators.igualSenha],
      telefone: [],
      celular: [],
      cidade: [],
      estado: [],
      date_format: [],
      time_format: [],
      timezone: [],
      avatar: [],
      idioma: []
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    this.clientesService.get(null, null, ['id_cliente', 'nome_tratamento'])
      .subscribe(
        json => {
          this.listClientes = json.Payload;

          if(this.global.debug == true){
            console.log('listClientes', json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });


    let id = this.route.params.subscribe(params => {
      let id = params['id_usuario'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarUsuario');
      }else{
        this.title = (id) ? this.func.traduzir('front.visualizarUsuario') : this.func.traduzir('front.cadastrarNovoUsuario');
      }


      this.paisesService.get()
        .subscribe(
          json => {
            this.listPaises = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });


      this.usuariosService.timezone()
        .subscribe(
          json => {
            this.listTimezone = json.Payload
          },
          error => {
            this.func.showErro(error.json());
          });

      if (!id) {
        return;
      }

      // verifica se a pagina é do usuario
      if(id == this.func.getTokenInfo()['uid']){
        this.isMinhaConta = true;
      }

      this.usuariosService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarUsuario') + ': ' + json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarUsuario') + ': ' + json.Payload[0].nome;
            }
            this.user = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },error => {
            this.trataErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
      userValue = this.user; //this.form.value;

    if (userValue.id_usuario) {
      result = this.usuariosService.editar(userValue, userValue.id_usuario);
    } else {
      result = this.usuariosService.adicionar(userValue);
    }

    result.subscribe(
      (data) => {
        this.router.navigate(['/painel', 'clientes', 'usuarios']);
      },
      (erro) => {
        this.enviando = false;
        let json = erro.json();
        this.trataErro(json);

        for(let i in json.Message.ErrorInput){
          let erro = {};
          erro[i] = json.Message.ErrorInput[i];
          this.form.controls[i].setErrors(erro);
        }

      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/clientes-usuarios/clientes-usuarios-form.component.ts